module.exports = __webpack_public_path__ + "img/LATIN10_04.db37b8c8.jpg";